module.exports = __webpack_public_path__ + "img/Frame-42.c1d08edd.svg";